import React, { PureComponent } from 'react'
import { Grid, Paper, ListItem } from '@material-ui/core'
import moment from 'moment'
import {
  EditableTextField,
  EditableSwitch,
  EditableNumericInput,
} from '../common/EditableComponents'

export default class InvoiceItem extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      approvalRequired: false,
      dueDate: 10,
      inventoryRequired: false,
      useOnePin: false,
      pinToApproveOrders: '',
      pinToDeleteOrders: '',
    }
  }

  onSave = () => {
    this.props.onSave(() => this.props.disableEdit())
  }

  onChange = (key) => (event) => {
    this.props.onChange(key, event.target.value)
  }

  onChangeApproval = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target.value
    if (key === 'useOnePin' && value) {
      this.props.onChangeShopSettings('pinToDeleteOrders', this.props.data.pinToApproveOrders)
    }
    this.props.onChangeShopSettings(key, value)
  }

  onChangeInventory = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target.value
    this.props.onChangeShopSettings(key, value)
  }

  onChangeNumber = (key, value) => {
    this.props.onChangeShopSettings(key, value)
  }

  onChangePin = (key, value) => {
    const re = /^[0-9\b]+$/

    if (
      (value.target.value === '' || re.test(value.target.value)) &&
      value.target.value.length <= 4
    ) {
      this.props.onChangeShopSettings(key, value.target.value)
    }
  }

  isValidDate = (current) => {
    return current > moment()
  }

  render() {
    const {
      editMode = false,
      data = {},
      title = '',
      isInvoice = false,
      isSales,
      shopOrderSettings,
    } = this.props

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page" elevation={2}>
              <ListItem>
                <Grid container>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <h2 className="nomargin">{title}</h2>
                  </Grid>
                </Grid>
              </ListItem>
              {isSales ? (
                <Grid>
                  <ListItem>
                    <Grid container alignItems="center">
                      <Grid className="labelField margin-bottom" item xs={12} sm={6} md={6} lg={6}>
                        Approval Required
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={
                            shopOrderSettings['approvalRequired'] ? 'Enabled' : 'Disabled'
                          }
                          editMode={editMode}
                          checked={shopOrderSettings['approvalRequired']}
                          onChange={this.onChangeApproval('approvalRequired', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  {shopOrderSettings.approvalRequired ? (
                    <Grid>
                      <ListItem>
                        <Grid
                          className="labelField margin-bottom"
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={6}
                        >
                          Use one PIN to approve and delete
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <EditableSwitch
                            valueToRender={shopOrderSettings.useOnePin ? 'Enabled' : 'Disabled'}
                            editMode={editMode}
                            checked={shopOrderSettings.useOnePin}
                            onChange={this.onChangeApproval('useOnePin', true)}
                          />
                        </Grid>
                      </ListItem>
                    </Grid>
                  ) : null}
                  {shopOrderSettings.approvalRequired && !shopOrderSettings.useOnePin ? (
                    <Grid>
                      <ListItem>
                        <Grid container alignItems="center">
                          <Grid
                            className="labelField margin-bottom"
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                          >
                            PIN to approve orders
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <EditableTextField
                              editMode={editMode}
                              type="text"
                              value={shopOrderSettings.pinToApproveOrders}
                              valueToRender={shopOrderSettings.pinToApproveOrders}
                              onChange={(e) => this.onChangePin('pinToApproveOrders', e)}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <Grid container alignItems="center">
                          <Grid
                            className="labelField margin-bottom"
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                          >
                            PIN to delete orders
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <EditableTextField
                              editMode={editMode}
                              type="text"
                              value={shopOrderSettings.pinToDeleteOrders}
                              valueToRender={shopOrderSettings.pinToDeleteOrders}
                              onChange={(e) => this.onChangePin('pinToDeleteOrders', e)}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    </Grid>
                  ) : shopOrderSettings.approvalRequired && shopOrderSettings.useOnePin ? (
                    <Grid>
                      <ListItem>
                        <Grid container alignItems="center">
                          <Grid
                            className="labelField margin-bottom"
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                          >
                            PIN to approve or delete orders
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <EditableTextField
                              editMode={editMode}
                              type="text"
                              value={shopOrderSettings.pinToApproveOrders}
                              valueToRender={shopOrderSettings.pinToApproveOrders}
                              onChange={(e) => {
                                this.onChangePin('pinToApproveOrders', e)
                                this.onChangePin('pinToDeleteOrders', e)
                              }}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    </Grid>
                  ) : null}
                  <ListItem>
                    <Grid container alignItems="center">
                      <Grid className="labelField margin-bottom" item xs={12} sm={6} md={6} lg={6}>
                        SO Inventory Required
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={
                            shopOrderSettings['inventoryRequired'] ? 'Enabled' : 'Disabled'
                          }
                          editMode={editMode}
                          checked={shopOrderSettings['inventoryRequired']}
                          onChange={this.onChangeInventory('inventoryRequired', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container alignItems="center">
                      <Grid className="labelField margin-bottom" item xs={12} sm={6} md={6} lg={6}>
                        Default Due Date (Days)
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <EditableNumericInput
                          placeholder=""
                          valueToRender={`${shopOrderSettings['date'] || 1}` + '  Days'}
                          value={shopOrderSettings['date']}
                          className="numeric-material-input"
                          mobile={false}
                          onChange={(e) => this.onChangeNumber('date', e)}
                          min={1}
                          max={90}
                          precision={0}
                          editMode={editMode}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                </Grid>
              ) : (
                <Grid>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={4} lg={4}>
                        Terms & Conditions
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={8} lg={8}>
                        <EditableTextField
                          valueToRender={
                            data[isInvoice ? 'invoiceTermCondition' : 'poTermCondition'] || ''
                          }
                          editMode={editMode}
                          value={data[isInvoice ? 'invoiceTermCondition' : 'poTermCondition'] || ''}
                          onChange={this.onChange(
                            isInvoice ? 'invoiceTermCondition' : 'poTermCondition',
                          )}
                          type="text"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={4} lg={4}>
                        Notes
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={8} lg={8}>
                        <EditableTextField
                          valueToRender={data[isInvoice ? 'invoiceNote' : 'poNote'] || ''}
                          editMode={editMode}
                          value={data[isInvoice ? 'invoiceNote' : 'poNote'] || ''}
                          onChange={this.onChange(isInvoice ? 'invoiceNote' : 'poNote')}
                          type="text"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                </Grid>
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InvoicesAndPurchaseOrders/InvoiceItem.js